var BaseView = require('./base');

module.exports = BaseView.extend({
  uploadConfig: {
    validation: {
      acceptFiles: '.svg',
      allowedExtensions: ['svg']
    },
    uploadSuccess: {params: {loadType: 120}}
  },

  appendThumbnails: function (data) {
    var $content = this.$el.find('.thumbnail-wrapper');

    _.delay(_.bind(function () {
      var results = _.each(this.extractSvgData(data), function (svgThumb) {
        this.$el.find('#' + svgThumb.uuid).length || svgThumb.appendTo($content);
        var $item = this.$el.find('#' + svgThumb.uuid);

        $item.after(this.tool.getOverlayHtml(this.$el, 'sticker'));
        $item.siblings('.overlay').find('[data-type=delete]').off('click').on('click',
            _.partial(this.tool.removeImportedElement, _.partial(this.deleteOverlayCallback, $item)));

        this.addDeleteOverlay($item);
      }, this);

      results.length && this.$el.siblings('.section-title').css('visibility', '');

      this.masonryReload();
    }, this), 500
    );
  },

  extractSvgData: function (data) {
    return _.compact(_.map(data, function (item) {
      if (item.type === 'svg') {
        return new INKIVE.ThumbSvg(item);
      }
    }, this));
  },

  getScrollHeight: function ($target) {
    var $tabContent = $target.closest('.tab-content');
    var containerHeight = $tabContent.height();

    containerHeight -= $tabContent.find('.header-links').height();
    $target.siblings().add($target.parent().siblings()).each(function () {
      containerHeight -= $(this).height();
    });

    return containerHeight;
  }
});
